// Global Shoplift Test JS


/////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// TEST - [CHS-129] [Sitewide] Header/Nav Sales Category Red Emphasis 
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// Initialize test
async function initTestCHS_129() {
	
	// Configuration
	const TEST_ID = 'CHS_129';
	const HYPOTHESIS_ID = '019dbb48-939f-7f60-8cdc-df4a791dd17c';
	let variantResult = null;
	
	if (!window.shoplift) {
	console.warn('Shoplift not available');
	return;
	}

	try {
	// Check if visitor is in the variant group
	variantResult = await window.shoplift.isHypothesisActive(HYPOTHESIS_ID);

		if (variantResult) {
			// Create or reuse the canonical style CSS (append-safe)
			const STYLE_ID = `${TEST_ID}-CSS`;
			let style = document.getElementById(STYLE_ID);

			if (!style) {
				style = document.createElement('style');
				style.id = `${TEST_ID}-CSS`;
				document.head.appendChild(style);
			}

			// Append CSS rules (does NOT overwrite existing ones)
			// TEST - Show Variant
			
			style.appendChild(
				document.createTextNode(`
				/* ${style.id} - Nav Category Sales Red Highlight */

					li.menu-list__list-item:nth-child(7) .menu-list__link-title.caption {
						color: #D10707!important;
						}
				`)
			);
			console.log(`Showing ${TEST_ID} Variant`);
		} else {
			// Show control
			// NO CHANGES DO NOTHING
			console.log(`Showing ${TEST_ID} Control`);
		}
	} catch (error) {
		// Always fail gracefully - show control experience on error
		console.error(`Shoplift test ${TEST_ID} failed:`, error);
		}
		
}

document.addEventListener('DOMContentLoaded', initTestCHS_129);

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////